export const googleSheetURLFormat =
  'https://docs.google.com/spreadsheets/d/{{document_id}}/edit#gid={{sheet_id}}' as const
